module.exports = __webpack_public_path__ + "static/media/hand-holding-seedling.30d28300.svg";